export default "__VITE_ASSET__DxcK5bk5__"